import React, { useContext, useState } from "react";
import { Button, Col, Row, Spin } from "antd";
import AsideBlock from "../../../components/AsideBlock";
import { InvigilationCtx } from "../../../context";
import { getExamStudentDownloadRecordInfo } from "../../../../../../service/exam";
import styles from "../../../camCaptureRecord/index.module.scss";
import DownloadModal from "../DownloadModal";
import useExamInfo from "../../../Hook/useExamInfo";

export default function AsideDownload() {
    const [showModal, setShowModal] = useState(false);
    const { currentData } = useContext(InvigilationCtx);
    const [data, { loading }] = useExamInfo(
        getExamStudentDownloadRecordInfo,
        currentData
    );
    return (
        <AsideBlock
            title="下载附件记录"
            count={data?.downloadList?.length}
            extra={
                <Button
                    type="link"
                    className={styles.button}
                    onClick={() => setShowModal(true)}>
                    查看更多&gt;
                </Button>
            }>
            <Spin spinning={loading}>
                {data?.downloadList?.slice(0, 6).map((item, index) => (
                    <Row key={index} type="flex">
                        <Col span={8}>{item.time}</Col>
                        <Col key={index} span={8}>
                            {item.fileName}
                        </Col>
                    </Row>
                ))}

                {data?.downloadList?.length === 0 && (
                    <Row>
                        <Col span={24}>无下载记录</Col>
                    </Row>
                )}
            </Spin>

            <DownloadModal
                visible={showModal}
                data={data?.downloadList || []}
                onCancel={() => setShowModal(false)}
            />
        </AsideBlock>
    );
}
